import React from 'react';
import { ListChecks, Search, Wallet2, ArrowRight } from 'lucide-react';
import '../../../../../styles/components/auction-payment-detail.scss';

const SKELETON_CARD_COUNT = 4;

function SkeletonAuctionCard({ index }) {
  return (
    <div className="ap-auction-card aps-card" aria-hidden="true" key={index}>
      <div className="ap-auction-card__top">
        <span className="aps-checkbox" />
        <span className="aps-icon" />
        <div className="ap-auction-card__identity">
          <span className="aps-line aps-line--title" />
          <span className="aps-line aps-line--sub" />
        </div>
        <div className="ap-auction-card__amount">
          <span className="aps-line aps-line--amount" />
          <span className="aps-line aps-line--label" />
        </div>
      </div>

      <div className="ap-progress aps-progress-bar" />

      <div className="ap-auction-card__stats">
        {[0, 1, 2, 3].map((i) => (
          <div className="ap-stat" key={i}>
            <span className="aps-line aps-line--stat-label" />
            <span className="aps-line aps-line--stat-value" />
          </div>
        ))}
      </div>

      <div className="ap-auction-card__footer">
        <div className="ap-auction-card__badges">
          <span className="aps-pill" />
          <span className="aps-pill aps-pill--wide" />
        </div>
        <span className="aps-expand-btn" />
      </div>
    </div>
  );
}

/**
 * Loading placeholder for AuctionPaymentDetail. Deliberately reuses the
 * real ap-* structural classes (panel/card/grid/summary-row) so the
 * skeleton occupies exactly the same space as the real content once it
 * loads — no layout shift on swap. Only the content INSIDE each element
 * is skeleton-specific, under the aps- namespace, kept separate from
 * ap-* so nothing here can accidentally leak real styling or collide
 * with other skeletons (e.g. TableSkeleton) elsewhere in the app.
 */
export default function AuctionPaymentDetailSkeleton() {
  return (
    <div className="ap-page" aria-busy="true" aria-live="polite">
      <div className="ap-shell">
        <div className="ap-columns">
          {/* ---------------- Left: Auction Selection ---------------- */}
          <section className="ap-panel ap-panel--selection">
            <div className="ap-panel__head">
              <h2 className="aps-heading-row">
                <ListChecks size={18} />
                <span className="aps-line aps-line--heading" />
              </h2>
              <span className="aps-line aps-line--count" />
            </div>

            <div className="ap-toolbar">
              <div className="ap-search">
                <Search size={16} />
                <span className="aps-line aps-line--search" />
              </div>
              <span className="aps-block aps-block--sort" />
              <span className="aps-block aps-block--select-all" />
            </div>

            <div className="ap-auction-list">
              {Array.from({ length: SKELETON_CARD_COUNT }).map((_, i) => (
                <SkeletonAuctionCard key={i} index={i} />
              ))}
            </div>
          </section>

          {/* ---------------- Right: Payment Summary ---------------- */}
          <aside className="ap-panel ap-panel--summary">
            <div className="ap-panel__head">
              <h2 className="aps-heading-row">
                <Wallet2 size={18} />
                <span className="aps-line aps-line--heading" />
              </h2>
            </div>

            <div className="ap-progress-card">
              <span className="aps-ring" />
              <div className="ap-progress-card__body">
                <span className="aps-line aps-line--progress-label" />
                <span className="aps-line aps-line--progress-value" />
              </div>
            </div>

            <div className="ap-summary-rows">
              {Array.from({ length: 4 }).map((_, i) => (
                <div className="ap-summary-row" key={i}>
                  <span className="aps-line aps-line--row-label" />
                  <span className="aps-line aps-line--row-value" />
                </div>
              ))}
            </div>

            <div className="ap-dest-options">
              {Array.from({ length: 2 }).map((_, i) => (
                <div className="ap-dest-option aps-dest-option" key={i}>
                  <span className="aps-dest-radio" />
                  <span className="aps-dest-icon" />
                  <div className="ap-dest-option__text">
                    <span className="aps-line aps-line--dest-title" />
                    <span className="aps-line aps-line--dest-sub" />
                  </div>
                  <span className="aps-line aps-line--dest-amount" />
                </div>
              ))}
            </div>

            <button type="button" className="ap-proceed-btn aps-proceed-btn" disabled>
              <ArrowRight size={16} />
              <span className="aps-line aps-line--btn" />
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
}
